"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermsOfServiceCheckbox = void 0;
const react_1 = __importDefault(require("react"));
const pactsafe_react_sdk_1 = require("@pactsafe/pactsafe-react-sdk");
const TermsOfServiceCheckbox = ({ groupKey, onDisplayed, onInvalid, onValid, signerId, testMode, }) => {
    const accessId = '81e8ee67-11ac-47dc-9128-00fbdf0bf3c8';
    return (react_1.default.createElement(pactsafe_react_sdk_1.PSClickWrap, { accessId: accessId, allowDisagreed: true, clickWrapStyle: "checkbox", groupKey: groupKey, onDisplayed: onDisplayed, onInvalid: onInvalid, onValid: onValid, signerId: signerId, testMode: testMode }));
};
exports.TermsOfServiceCheckbox = TermsOfServiceCheckbox;
exports.default = exports.TermsOfServiceCheckbox;
